import React, { ReactElement, useRef } from 'react'
import cx from 'classnames'
import * as styles from '../../styles/components/content-blocks/story.module.scss'
import reactElementToString from '../../utils/react-element-to-string'
import { motion, useScroll, useTransform } from 'framer-motion'
import { bezierEaseIn } from '../../utils/styles'
import Heading from '../heading'
import SmallTitle from '../small-title'
import CaptionText from '../caption-text'
import ContentWrapper from '../content-wrapper'
import Video from '../video'

interface Story {
    title: string
    body: ReactElement | string
    vimeoId?: string
}

export interface StoryBlockProps {
    title?: string
    stories: Story[]
    className?: string
}

export const StoryBlock = (props: StoryBlockProps) => {
    const {
        className, title, stories,
    } = props
    const targetRef = useRef<HTMLDivElement>(null)
    const { scrollYProgress } = useScroll({ target: targetRef, offset: ['start end', 'start start'] })
    const opacity = useTransform(scrollYProgress, [0.1, 0.7], [0, 1], { ease: bezierEaseIn })

    return (
        <ContentWrapper
            ref={targetRef}
            className={cx(styles.container, className)}
        >
            <motion.span style={{ opacity }}>
                {title && <Heading>{title}</Heading> }
            </motion.span>

            <div className={styles.storiesContainer}>

                {stories.map((story, index) =>
                    <motion.div key={index} style={{ opacity }} className={styles.storyContainer}>
                        {story.title &&
                        <SmallTitle className={styles.title} as="h3">
                            {story.title}
                        </SmallTitle>
                        }
                        <CaptionText
                            className={styles.body}
                            dangerouslySetInnerHTML={{ __html: reactElementToString(story.body) }}
                        />
                        {story.vimeoId && <Video vimeoId={story.vimeoId} /> }
                    </motion.div>,
                )}
            </div>
        </ContentWrapper>
    )
}
